export default {
  contacts: [],
};
